export default __webpack_public_path__ + "static/media/ic-table-grid.25acb377.svg";